import { render } from "./TutorialManage.vue?vue&type=template&id=f1d45db6&scoped=true"
import script from "./TutorialManage.vue?vue&type=script&lang=js"
export * from "./TutorialManage.vue?vue&type=script&lang=js"

import "./TutorialManage.vue?vue&type=style&index=0&id=f1d45db6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d45db6"]])

export default __exports__